import Chips from '../../../../../material-ui/chips/chips';
import React from 'react';
import {PrepaidTableContext} from "../../../prepaid-context";

function FilterChips() {

  const {filters, deleteFilter} = React.useContext(PrepaidTableContext);

  return <Chips onDelete={deleteFilter} values={filters}/>
}

export default FilterChips;


